export interface Platform {
  name: string;
  description: string;
  features: string[];
  rating: number;
  icon: string;
  url: string;
}

export const platforms: Platform[] = [
  {
    name: 'GayTube Premium',
    description: '全球最大的gay片在线观看平台之一，拥有海量高清gay片资源库，内容涵盖欧美、亚洲、日本等多个地区的优质gay片。支持多设备同步观看，更新速度快，画质出色。',
    features: ['海量gay片资源', '4K超清画质', '多设备同步', '每周更新', '个性化推荐'],
    rating: 4.8,
    icon: 'ri-play-circle-line',
    url: '#',
  },
  {
    name: 'BearFlix',
    description: '专注于熊族gay片和阳刚型gay片内容的垂直平台，内容精准聚焦，社区氛围浓厚，是熊族gay片爱好者的首选聚集地。提供独家内容和定期线上活动。',
    features: ['熊族gay片专精', '独家原创内容', '活跃社区', '会员专属活动', '高清下载'],
    rating: 4.6,
    icon: 'ri-user-heart-line',
    url: '#',
  },
  {
    name: 'AsiaGay TV',
    description: '亚洲gay片资源最丰富的平台之一，涵盖日本、韩国、泰国、台湾等地区的优质gay片内容，提供中文字幕和本土化推荐服务，用户体验优秀。',
    features: ['亚洲gay片全覆盖', '中文字幕', '本土化推荐', '日更内容', '多语言界面'],
    rating: 4.7,
    icon: 'ri-earth-line',
    url: '#',
  },
  {
    name: 'IndieGay Studio',
    description: '独立gay片创作者的首选发布平台，汇聚了全球各地的优质独立gay片作品。注重艺术性和创新性，为观众提供不同于主流gay片厂牌的独特内容体验。',
    features: ['独立gay片精选', '艺术性强', '支持创作者', '独特视角', '限量内容'],
    rating: 4.5,
    icon: 'ri-movie-2-line',
    url: '#',
  },
  {
    name: 'SafeViewer Pro',
    description: '以隐私保护和安全观影为核心特色的gay片平台，提供端到端加密、无痕浏览和匿名支付等高级安全功能。适合注重隐私保护的gay片观众使用。',
    features: ['端到端加密', '无痕浏览', '匿名支付', '自动清除记录', 'VPN兼容'],
    rating: 4.4,
    icon: 'ri-shield-check-line',
    url: '#',
  },
  {
    name: 'ClassicGay Archive',
    description: '专注于经典gay片收藏与修复的专业平台，收录了gay片发展史上的重要作品。提供修复版高清gay片资源和详细的作品背景资料，是gay片文化研究者的宝库。',
    features: ['经典gay片修复', '文化档案', '专家解说', '历史资料', '限量发行'],
    rating: 4.7,
    icon: 'ri-archive-line',
    url: '#',
  },
];